import { BaseLayout } from '@uag/react-core';

import { SettingContainer } from 'app/modules/wallforming/components/setting-container/SettingContainer';

export const CataloguePage = () => {
    return (
        <div className="max-h-screen max-w-screen overflow-hidden">
            <BaseLayout
                className="bg-background-gray-ultra-ultra-light overflow-hidden"
                environment={import.meta.env.VITE_ENVIRONMENT}
                innerClassName="h-full w-full overflow-hidden"
                showFooter={true}
                versionNumber={APP_VERSION}
                withCookieBanner={false}
            >
                <div className="w-full h-full overflow-hidden">
                    <SettingContainer />
                </div>
            </BaseLayout>
        </div>
    );
};
